import { render, staticRenderFns } from "./BSButton.vue?vue&type=template&id=61bcac59&"
import script from "./BSButton.vue?vue&type=script&lang=js&"
export * from "./BSButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports